export default new Error('useMemed must be used within MemedProvider.')
